const AgentEndpoints = {
  GET_THREADS: (offset: number, limit: number, workspaceId: string) =>
    `/agent/threads/?offset=${offset}&limit=${limit}&workspace_id=${workspaceId}`,

  GET_THREAD_MESSAGES: (threadId: string, offset: number, limit: number) =>
    `/agent/threads/${threadId}/messages/?offset=${offset}&limit=${limit}`,

  EXECUTE_AGENT: () => "/agent/execute/",

  CANCEL_AGENT: () => "/agent/cancel/",

  GET_AGENT_RUNS: (threadId: string, status?: string) => {
    const statusPart = status ? `&status=${status}` : "";
    return `/agent/agent-runs/?thread_id=${threadId}${statusPart}`;
  },

  GET_STREAM: (threadId: string) => `/agent/threads/${threadId}/stream/`,

  DOWNLOAD_SANDBOX_FILE: (filePath: string) => `/agent/sandbox/files/download/?path=${encodeURIComponent(filePath)}`,

  UPLOAD_SANDBOX_FILE: () => "/agent/sandbox/files/",

  GET_THREAD_COSTS: (threadId: string) => `/agent/threads/${threadId}/costs/`,

  GET_COMMANDS: (workspaceId: string) => `/agent/commands/?workspace_id=${workspaceId}`,

  GET_COMMAND: (commandId: string) => `/agent/commands/${commandId}/`,

  CREATE_COMMAND: () => `/agent/commands/`,

  UPDATE_COMMAND: (commandId: string) => `/agent/commands/${commandId}/`,

  DELETE_COMMAND: (commandId: string) => `/agent/commands/${commandId}/`,

  GET_SUB_AGENTS: (workspaceId: string) => `/agent/sub-agents/?workspace_id=${workspaceId}`,

  GET_SUB_AGENT: (subAgentId: string) => `/agent/sub-agents/${subAgentId}/`,

  CREATE_SUB_AGENT: () => `/agent/sub-agents/`,

  UPDATE_SUB_AGENT: (subAgentId: string) => `/agent/sub-agents/${subAgentId}/`,

  DELETE_SUB_AGENT: (subAgentId: string) => `/agent/sub-agents/${subAgentId}/`,

  LIST_SANDBOX_FILES: (basePath: string) => `/agent/sandbox/files/?path=${encodeURIComponent(basePath)}`,

  DELETE_SANDBOX_FILE: (filePath: string) => `/agent/sandbox/files/?path=${encodeURIComponent(filePath)}`,

  GET_MODELS: () => "/agent/models/",
};

export default AgentEndpoints;
